import { useEffect } from "react";

export default function AICreations() {

useEffect(() => {

const tabs = document.querySelectorAll('.tab-btn');
const videoCards = document.querySelectorAll('.video-card');

// Filtering Logic
tabs.forEach(tab => {
    tab.addEventListener('click', () => {

        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');

        const filterValue = tab.getAttribute('data-filter');

        videoCards.forEach(card => {

            if (filterValue === 'all' || card.getAttribute('data-category') === filterValue) {
                card.style.display = 'block';
            } else {
                card.style.display = 'none';
            }

        });

    });
});


const stabs = document.querySelectorAll('.tab-btns');
const svideoCards = document.querySelectorAll('#videoGrid2 .video-card2');

stabs.forEach(tab => {

    tab.addEventListener('click', () => {

        stabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');

        const filterValue = tab.getAttribute('data-filter');

        svideoCards.forEach(card => {

            if (filterValue === 'all' || card.getAttribute('data-category') === filterValue) {
                card.style.display = 'block';
            } else {
                card.style.display = 'none';
            }

        });

    });

});


/* =========================
VIDEO POPUP LOGIC
========================= */

const modal = document.getElementById("videoModal");
const popupVideo = document.getElementById("popupVideo");
const closeBtn = document.querySelector(".close-video");

const videoWrappers = document.querySelectorAll('.video-wrapper');

videoWrappers.forEach(wrapper => {

    wrapper.addEventListener('click', function () {

        const source = wrapper.querySelector('video source');

        if (!source) return;

        popupVideo.src = source.src;

        modal.classList.add("active");

        popupVideo.play().catch(err => console.log(err));

    });

});


// close button
closeBtn?.addEventListener("click", () => {

    modal.classList.remove("active");

    popupVideo.pause();
    popupVideo.currentTime = 0;
    popupVideo.src = "";

});


// outside click close
modal?.addEventListener("click", (e) => {

    if (e.target === modal) {

        modal.classList.remove("active");

        popupVideo.pause();
        popupVideo.currentTime = 0;
        popupVideo.src = "";

    }

});



/* =========================
LOAD MORE LOGIC
========================= */

const loadMoreBtn = document.querySelector('.load-more-btn');
let itemsToShow = 6;

function updateVisibility() {

    const activeTab = document.querySelector('.tab-btn.active').getAttribute('data-filter');
    const allCards = document.querySelectorAll('.video-card');

    const filteredCards = Array.from(allCards).filter(card => {
        return activeTab === 'all' || card.getAttribute('data-category') === activeTab;
    });

    allCards.forEach(card => card.style.display = 'none');

    filteredCards.slice(0, itemsToShow).forEach(card => {
        card.style.display = 'block';
    });

    if (itemsToShow >= filteredCards.length) {
        loadMoreBtn.style.display = 'none';
    } else {
        loadMoreBtn.style.display = 'inline-block';
    }

}

loadMoreBtn?.addEventListener('click', () => {
    itemsToShow += 6;
    updateVisibility();
});

tabs.forEach(tab => {
    tab.addEventListener('click', () => {
        itemsToShow = 6;
        updateVisibility();
    });
});

updateVisibility();

}, []);

  return (
    <>
    <main className="container portfolio-main">
            <section className="hero">
                <h1>Our Video Portfolio</h1>
                <p>Explore our creative work across <strong>categories</strong></p>
            </section>

            <section className="filter-tabs">
                <button className="tab-btn active" data-filter="all">All</button>
            {/* <button className="tab-btn" data-filter="animated">Animated Post</button> */}
                <button className="tab-btn" data-filter="featured">Featured</button>
                <button className="tab-btn" data-filter="coming">Coming Soon</button>
                <button className="tab-btn" data-filter="info">Info & Overviews</button>
                <button className="tab-btn" data-filter="logo">Loader & Logo Animation</button>
                <button className="tab-btn" data-filter="motion">Motion Graphics</button>
                <button className="tab-btn" data-filter="ai">Videos using A.I</button>
            </section>

        <div className="video-grid" id="videoGrid">

            {/* <div className="video-card" data-category="info">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/info-1.mp4" type="video/mp4" />
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">01:24</span>
                </div>
                <div className="card-info">
                    <h3>3 Dealing with Road Traffic Accidents</h3>
                    <p>Info & Overviews</p>
                </div>
            </div> */}
            <div className="video-card" data-category="info">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/info-2.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">01:24</span>
                </div>
                <div className="card-info">
                    <h3>AAM Steps</h3>
                    <p>Info & Overviews</p>
                </div>
            </div>
            <div className="video-card" data-category="info">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/info-3.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">01:24</span>
                </div>
                <div className="card-info">
                    <h3>Alt Cap</h3>
                    <p>Info & Overviews</p>
                </div>
            </div>
            <div className="video-card" data-category="info">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/info-4.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">01:24</span>
                </div>
                <div className="card-info">
                    <h3>Callenza Promotional Video</h3>
                    <p>Info & Overviews</p>
                </div>
            </div>
            {/* <div className="video-card" data-category="info">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/info-5.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">01:24</span>
                </div>
                <div className="card-info">
                    <h3>RH Fleet 4</h3>
                    <p>Info & Overviews</p>
                </div>
            </div> */}
            {/* <div className="video-card" data-category="info">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/info-6.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">01:24</span>
                </div>
                <div className="card-info">
                    <h3>VUE (App)</h3>
                    <p>Info & Overviews</p>
                </div>
            </div> */}
            {/* <div className="video-card" data-category="info">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/info-7.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">01:24</span>
                </div>
                <div className="card-info">
                    <h3>VUE Rec45MB</h3>
                    <p>Info & Overviews</p>
                </div>
            </div> */}


            <div className="video-card" data-category="coming">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/coming-1.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Diwali Coming</h3>
                    <p>Coming Soon</p>
                </div>
            </div>
            <div className="video-card" data-category="coming">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/coming-2.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Ozone Coming</h3>
                    <p>Coming Soon</p>
                </div>
            </div>
            <div className="video-card" data-category="logo">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/logo-1.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>9xtream Loader</h3>
                    <p>Loader & Logo Animation</p>
                </div>
            </div>
             <div className="video-card" data-category="logo">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/logo-2.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>AGP Logo</h3>
                    <p>Loader & Logo Animation</p>
                </div>
            </div>
             <div className="video-card" data-category="logo">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/logo-3.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Arihant logo</h3>
                    <p>Loader & Logo Animation</p>
                </div>
            </div>
             <div className="video-card" data-category="logo">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/logo-4.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>H2S</h3>
                    <p>Loader & Logo Animation</p>
                </div>
            </div>
             <div className="video-card" data-category="logo">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/logo-5.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Kuwait better</h3>
                    <p>Loader & Logo Animation</p>
                </div>
            </div>
             <div className="video-card" data-category="logo">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/logo-6.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Kuwait News</h3>
                    <p>Loader & Logo Animation</p>
                </div>
            </div>
            {/* <div className="video-card" data-category="logo">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/logo-7.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Logo Animate</h3>
                    <p>Loader & Logo Animation</p>
                </div>
            </div> */}
             <div className="video-card" data-category="logo">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/logo-8.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>New Media Maker</h3>
                    <p>Loader & Logo Animation</p>
                </div>
            </div>
             <div className="video-card" data-category="logo">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/logo-9.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>New S2H</h3>
                    <p>Loader & Logo Animation</p>
                </div>
            </div>
             <div className="video-card" data-category="logo">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/logo-10.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>S2H Loader</h3>
                    <p>Loader & Logo Animation</p>
                </div>
            </div>
             <div className="video-card" data-category="logo">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/logo-11.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>S2H Logo Animation</h3>
                    <p>Loader & Logo Animation</p>
                </div>
            </div>
             <div className="video-card" data-category="logo">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/logo-12.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Sabah</h3>
                    <p>Loader & Logo Animation</p>
                </div>
            </div>
            <div className="video-card" data-category="motion">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/motion-1.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Beaker</h3>
                    <p>Motion Graphics</p>
                </div>
            </div>
            <div className="video-card" data-category="motion">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/motion-2.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Dark Green</h3>
                    <p>Motion Graphics</p>
                </div>
            </div>
            <div className="video-card" data-category="motion">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/motion-3.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Green</h3>
                    <p>Motion Graphics</p>
                </div>
            </div>
            <div className="video-card" data-category="motion">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/motion-4.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Mining Animation</h3>
                    <p>Motion Graphics</p>
                </div>
            </div>
            <div className="video-card" data-category="motion">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/motion-5.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>New Mining Animation (After Click)</h3>
                    <p>Motion Graphics</p>
                </div>
            </div>
            <div className="video-card" data-category="motion">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/motion-6.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>New Mining Animation (Before Click)</h3>
                    <p>Motion Graphics</p>
                </div>
            </div>
            <div className="video-card" data-category="motion">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/motion-7.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>New S2H (King)</h3>
                    <p>Motion Graphics</p>
                </div>
            </div>
            <div className="video-card" data-category="motion">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/motion-8.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Red</h3>
                    <p>Motion Graphics</p>
                </div>
            </div>
            <div className="video-card" data-category="motion">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/motion-9.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>S2H App Overview</h3>
                    <p>Motion Graphics</p>
                </div>
            </div>
            <div className="video-card" data-category="motion">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/motion-10.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>S2H Smart Glass Use (Bank Side)</h3>
                    <p>Motion Graphics</p>
                </div>
            </div>
            <div className="video-card" data-category="motion">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/motion-11.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>S2H Smart Glass Use (Customer Side)</h3>
                    <p>Motion Graphics</p>
                </div>
            </div>
            <div className="video-card" data-category="motion">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/motion-12.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>S2H Teacher</h3>
                    <p>Motion Graphics</p>
                </div>
            </div>
            <div className="video-card" data-category="ai">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/ai-1.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Altcap Comic</h3>
                    <p>Videos using A.I</p>
                </div>
            </div>
             <div className="video-card" data-category="ai">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/ai-2.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Altcap Rules</h3>
                    <p>Videos using A.I</p>
                </div>
            </div>
             <div className="video-card" data-category="ai">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/ai-3.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Altcap Story</h3>
                    <p>Videos using A.I</p>
                </div>
            </div>
             <div className="video-card" data-category="ai">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/ai-4.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Altcap World</h3>
                    <p>Videos using A.I</p>
                </div>
            </div>
            
             <div className="video-card" data-category="ai">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/ai-7.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Callenza Promotional</h3>
                    <p>Videos using A.I</p>
                </div>
            </div>
             <div className="video-card" data-category="ai">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/ai-8.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Create Dr. Green</h3>
                    <p>Videos using A.I</p>
                </div>
            </div>
             








        </div>

        <div className="load-more-container">
            <button className="load-more-btn">Load More</button>
        </div>


        <section className="filter-tabs second-tabs" style={{ paddingTop: "60px" }}>
            <button className="tab-btns active" data-filter="animated">Animated Post</button>
            <button className="tab-btns" data-filter="ai">Videos using A.I</button>
        </section>
         <div className="video-grid" id="videoGrid2">
            <div className="video-card2" data-category="animated">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/Animated-Post-12.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:10</span>
                </div>
                <div className="card-info">
                    <h3>ANBR LIVE Post</h3>
                    <p>Animated Post</p>
                </div>
            </div>
            <div className="video-card2" data-category="animated">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/Animated-Post-1.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:10</span>
                </div>
                <div className="card-info">
                    <h3>Codeflix Dhanteras</h3>
                    <p>Animated Post</p>
                </div>
            </div>
            <div className="video-card2" data-category="animated">
                <div className="video-wrapper">
                    <video preload="metadata" playsInlin poster="">
                        <source src="/assets/videos/Animated-Post-2.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:10</span>
                </div>
                <div className="card-info">
                    <h3>Codeflix Christmas</h3>
                    <p>Animated Post</p>
                </div>
            </div>
            <div className="video-card2" data-category="animated">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/Animated-Post-3.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:10</span>
                </div>
                <div className="card-info">
                    <h3>Codeflix Christmas</h3>
                    <p>Animated Post</p>
                </div>
            </div>
            <div className="video-card2" data-category="animated">
                <div className="video-wrapper">
                    <video playsInline preload="metadata" poster="">
                        <source src="/assets/videos/Animated-Post-4.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:10</span>
                </div>
                <div className="card-info">
                    <h3>Codeflix Christmas</h3>
                    <p>Animated Post</p>
                </div>
            </div>
              <div className="video-card2" data-category="animated">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/Animated-Post-5.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:10</span>
                </div>
                <div className="card-info">
                    <h3>Codeflix Diwali</h3>
                    <p>Animated Post</p>
                </div>
            </div>
              <div className="video-card2" data-category="animated">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/Animated-Post-6.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:10</span>
                </div>
                <div className="card-info">
                    <h3>Codeflix 26 Jan</h3>
                    <p>Animated Post</p>
                </div>
            </div>
              <div className="video-card2" data-category="animated">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/Animated-Post-7.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:10</span>
                </div>
                <div className="card-info">
                    <h3>Davys 26 Jan</h3>
                    <p>Animated Post</p>
                </div>
            </div>
              <div className="video-card2" data-category="animated">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/Animated-Post-8.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:10</span>
                </div>
                <div className="card-info">
                    <h3>Davys Dhanteras</h3>
                    <p>Animated Post</p>
                </div>
            </div>
              <div className="video-card2" data-category="animated">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/Animated-Post-9.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:10</span>
                </div>
                <div className="card-info">
                    <h3>Davys Diwali</h3>
                    <p>Animated Post</p>
                </div>
            </div>
              <div className="video-card2" data-category="animated">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/Animated-Post-10.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:10</span>
                </div>
                <div className="card-info">
                    <h3>Codeflix New Year</h3>
                    <p>Animated Post</p>
                </div>
            </div>
              <div className="video-card2" data-category="animated">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/Animated-Post-11.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:10</span>
                </div>
                <div className="card-info">
                    <h3>Codeflix New Year</h3>
                    <p>Animated Post</p>
                </div>
            </div>
            <div className="video-card2" data-category="animated">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/Animated-Post-13.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:10</span>
                </div>
                <div className="card-info">
                    <h3>Lilloom New Year</h3>
                    <p>Animated Post</p>
                </div>
            </div>
            <div className="video-card2" data-category="ai">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/ai-9.mp4" type="video/mp4"/>
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Tulasi Jeeru</h3>
                    <p>Videos using A.I</p>
                </div>
            </div>
             <div className="video-card2" data-category="ai">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/ai-10.mp4" type="video/mp4" />
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Urban Gardening</h3>
                    <p>Videos using A.I</p>
                </div>
            </div>
             <div className="video-card2" data-category="ai">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/ai-5.mp4" type="video/mp4" />
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Arihant Trailer 2</h3>
                    <p>Videos using A.I</p>
                </div>
            </div>
            <div className="video-card2" data-category="ai">
                <div className="video-wrapper">
                    <video preload="metadata" playsInline poster="">
                        <source src="/assets/videos/ai-6.mp4" type="video/mp4" />
                    </video>
                    <div className="play-btn-overlay">
                        <div className="play-icon">▶</div>
                    </div>
                    <span className="duration">00:11</span>
                </div>
                <div className="card-info">
                    <h3>Arihant(Comic)1</h3>
                    <p>Videos using A.I</p>
                </div>
            </div>
         </div>
    </main>
    <div className="video-modal" id="videoModal">
    <div className="video-modal-content">
        <span className="close-video">&times;</span>

        <div className="video-container">
            <video id="popupVideo" controls playsInline>
                <source src="" type="video/mp4" />
            </video>
        </div>
    </div>
</div>
    </>
  );
}